import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import { Sign, Sensor } from './components';
import { GET_SIGN_STATE, GET_SENSOR_STATE } from './queries/device.queries';
import { SignDetailDialog, SensorDetailDialog } from './components/dialogs';

const DEVICE_DATA_POLL_INTERVAL = 1000;

const DeviceView = ({
  source,
}) =>
{

  const [openSignDetailDialog, setOpenSignDetailDialog] = useState(false);
  const [openSensorDetailDialog, setOpenSensorDetailDialog] = useState(false);

  if (source === undefined) {
    return null;
  }

  const handleSignDetailDialogOpen = () => {
    setOpenSignDetailDialog(true);
  };

  const handleSignDetailDialogClose = () => {
    setOpenSignDetailDialog(false);
  };

  const handleSignDetailDialogVerifyClicked = () => {
    setOpenSignDetailDialog(false);
  };

  const handleSensorDetailDialogOpen = () => {
    setOpenSensorDetailDialog(true);
  };

  const handleSensorDetailDialogClose = () => {
    setOpenSensorDetailDialog(false);
  };

  const handleSensorDetailDialogVerifyClicked = () => {
    setOpenSensorDetailDialog(false);
  };

  if (source.device_type === 'Sign') {
    return (
      <React.Fragment>
        {openSignDetailDialog ? <SignDetailDialog
          source={source}
          onVerifyClick={handleSignDetailDialogVerifyClicked}
          open={openSignDetailDialog}
          onClose={handleSignDetailDialogClose}
        /> : <React.Fragment />}
        <Query query={GET_SIGN_STATE} variables={{id: source.id}} pollInterval={DEVICE_DATA_POLL_INTERVAL}>
          {({ data, error, loading }) => {
            return (
              <Sign
                name={source.name}
                source={source}
                data={data} error={error}
                loading={loading}
                onClick={handleSignDetailDialogOpen}/>
            );
          }}
        </Query>
      </React.Fragment>
    );
  }

  if (source.device_type === 'TrafficSensor') {
    return (
      <React.Fragment>
        {openSensorDetailDialog ? <SensorDetailDialog
          source={source}
          onVerifyClick={handleSensorDetailDialogVerifyClicked}
          open={openSensorDetailDialog}
          onClose={handleSensorDetailDialogClose}
        /> : <React.Fragment />}
        <Query query={GET_SENSOR_STATE} variables={{id: source.id}} pollInterval={DEVICE_DATA_POLL_INTERVAL}>
          {({ data, error, loading }) => {
            return <Sensor name={source.name} data={data} error={error} loading={loading} onClick={handleSensorDetailDialogOpen}/>;
          }}
        </Query>
      </React.Fragment>
    );
  }

  return null;
};

DeviceView.propTypes = {
  source: PropTypes.object.isRequired
};

export default DeviceView;